import { Form, Select, notification } from 'antd'

import { useEffect, useState } from 'react'

import './TaskDrawer.style.less'
import TextList from './TextList'
import FooterForm from './FooterForm'
import { useUpdateTaskDetail } from '../TaskTable.hook'
import { useAuth } from '@/providers/auth.provider'

function AssigneeForm(props: any) {
  const {
    assignee,
    collaborators,
    id,
    refetch,
    canEdit,
    data: taskData,
  } = props
  const [form] = Form.useForm()
  const [onEdit, setOnEdit] = useState(false)

  const { mutate, isLoading, isSuccess, data, isError, error } =
    useUpdateTaskDetail()
  const formValue = Form.useWatch('user_id', form)
  const { user } = useAuth()

  const isUserAssignedAndIsUpdater = (): boolean => {
    const isCurrentUserAssign = taskData.assignee.id === user?.id
    const isUserPartOfCollaboration = taskData?.order?.assignments?.find(
      (assignment) => {
        return assignment?.user?.id === user?.id
      }
    )
    if (
      isCurrentUserAssign &&
      isUserPartOfCollaboration &&
      isUserPartOfCollaboration.roles.role === 'updater'
    ) {
      return false
    }
    return true
  }
  useEffect(() => {
    if (isError) {
      notification.error({
        message:
          (error as any)?.response?.data?.message ||
          'Unable to update assignee',
        duration: 4,
        placement: 'top',
      })
    }
  }, [isError])

  useEffect(() => {
    if (!isSuccess) return
    notification.success({
      message: 'Updated Assignee successfully.',
      duration: 4,
      placement: 'top',
    })
    setOnEdit(false)
    refetch()
  }, [isSuccess, data])

  const onFinish = (values: any) => {
    mutate({
      payload: { collaborations: [values] },
      type: 'assign',
      id,
    })
  }

  const handleCancel = () => {
    setOnEdit(false)
  }

  if (onEdit) {
    return (
      <div className="task-form">
        <Form
          form={form}
          onFinish={onFinish}
          layout="horizontal"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          colon={false}
          initialValues={{
            user_id: !!collaborators.find(
              (value) => value.user.id === assignee?.id
            )
              ? assignee?.id
              : undefined,
          }}
        >
          <Form.Item
            rules={[{ required: true }]}
            label="Assignee"
            name="user_id"
          >
            <Select
              placeholder="Select"
              size="middle"
              options={collaborators}
            />
          </Form.Item>
          <FooterForm
            disableSaveButton={!formValue}
            isLoading={isLoading}
            handleCancel={handleCancel}
          />
        </Form>
      </div>
    )
  }

  const getValue = () => {
    try {
      return data?.data[0]?.user
        ? data?.data[0]?.user?.first_name + ' ' + data?.data[0]?.user?.last_name
        : assignee?.name
    } catch (error) {
      return assignee?.name
    }
  }

  return (
    <TextList
      label="Assignee"
      value={getValue()}
      onClickEdit={() => setOnEdit(true)}
      isEditable={isUserAssignedAndIsUpdater() ?? canEdit}
    />
  )
}

export default AssigneeForm
